<template>
  <div>
    <!-- 历史版本，不删，后续可能有用 -->
    <!-- <div v-if="2==1" :class="{show_left: showBackNum}" class="backHome">
      <div @click='showBackFn' :class="{show_left_img: !showBackNum}" class="show_left_imgB item pointer ">
        <span>
          <img width="16px" v-show="showBackNum" src="@/assets/auto_img/base收起@2x (1).png" alt="">
          <img width="16px" v-show="!showBackNum" src="@/assets/auto_img/base收起@2x (2).png" alt="">
        </span>
      </div>
      <div @click="goUrl(-1)" class="item pointer ">
        <span> <img width="22px" src="@/assets/auto_img/icon_return@2x.png" alt=""></span>
      </div>
      <div class="item_line"></div>
      <div @click="goTop()" class="item pointer">
        <span> <img width="22px" src="@/assets/auto_img/icon_top@2x.png" alt=""></span>
      </div>
      <div class="item_line"></div>
      <div @click="toHome(baseData.home_page_id,'')" class="item pointer">
        <span> <img width="22px" src="@/assets/auto_img/icon_hp@2x.png" alt=""></span>
      </div>
    </div> -->

    <div v-if="meeting_data.back_menu_type==2&&baseData.home_page_id" :style="'background:'+meeting_data.back_menu_bgcolor+';'"
      class="backHome_top">
      <span class="pointer" @click="goUrl(-1)"> <img width="16px" src="@/assets/icon_return@2x (1).png" alt="">
        返回</span>
      <span style="flex:1"></span>
      <span class="pointer" @click="toHome(baseData.home_page_id,'')"> <img width="16px"
          src="@/assets/icon_home@2x (1).png" alt="">
        首页</span>
    </div>

    <div v-if="meeting_data.back_menu_type==1&&baseData.home_page_id" class="backHome_54">
      <div @click="toHome(baseData.home_page_id,'')" class="backHome_54_item">
        <img width="16px" src="@/assets/btn_home@2x.png" alt="">
        首页
      </div>
      <div class="backHome_54_line"></div>
      <div @click="goUrl(-1)" class="backHome_54_item">
        <img width="16px" src="@/assets/btn_return@2x.png" alt="">
        返回
      </div>
    </div>

  </div>
</template>

<script>
import $ from 'jquery'
export default {
  props: ['baseData', 'meeting_data'],
  data() {
    return {
      showBackNum: true
    }
  },
  mounted() {
    console.log(this.meeting_data)

    // window.onscroll = function () {
    //   clearTimeout(this.timeB)
    //   clearTimeout(this.timeC)
    //   document.querySelectorAll('.backHome')[0].style.right = '-145px'
    //   this.timeA = setTimeout(() => {
    //     document.querySelectorAll('.backHomeTwo')[0].style.right = '0px'
    //   }, 800);


    //   this.timeB = setTimeout(() => {
    //     this.timeC = setTimeout(() => {
    //       document.querySelectorAll('.backHome')[0].style.right = '0'
    //     }, 800);
    //     document.querySelectorAll('.backHomeTwo')[0].style.right = '-35px'
    //   }, 1500);
    // }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    showBackFn() {
      this.showBackNum = !this.showBackNum
    },
    goTop() {
      $('html,body').animate({
        scrollTop: 0
      }, 200);
    },
    toHome(id, str) {
      if (str) {
        window.location.href = str
        // window.open(str)
      } else if (id) {
        this.$router.push('/?view_id=' + id)
      } else {
        message.success('敬请期待！');
      }
    },
    goUrl(url) {
      // 在ios中路由跳转传参时不能使用query传参，要用 params传参，不然无法返回。
      if (url == -1) {
        if (window.history.length > 1) {
          if (Boolean(navigator.userAgent.match(/iphone|ipod|iOS/ig)) || Boolean(navigator.userAgent.match(/ipad/ig))) {
            history.go(-1)
          } else {
            window.history.go(-1)
          }
        } else if (this.baseData.home_page_id) {
          this.$router.push('/?view_id=' + this.baseData.home_page_id)
        }
      } else {
        this.$router.push(url)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.backHome_54 {
  position: fixed;
  right: 12px;
  bottom: 60px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  border: 1px solid #e0e0e0;
  backdrop-filter: blur(10px);
  flex-direction: column;
  border-radius: 23px;
  padding: 16px 0;
}
.backHome_54_line {
  width: 28px;
  height: 1px;
  background: #eeeeee;
  margin: 7px 0;
}
.backHome_54_item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  flex-direction: column;
  font-weight: 400;
  font-size: 10px;
  color: #aaaaaa;
  img {
    margin-bottom: 3px;
  }
}
.item_line {
  width: 1px;
  height: 16px;
  background-color: #ffffff;
  opacity: 0.5;
  margin: 0 12px;
}
.backHomeTwo,
.backHome {
  transition: all 1s;
  position: fixed;
  // right: -130px;
  right: -85px;
  bottom: 95px;
  z-index: 98;
  // width: 42px;
  height: 36px;
  border-radius: 23px;
  border: 1px solid #e0e0e0;
  // padding: 10px 0;
  text-align: center;
  font-size: 11px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #afafaf;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow: -1px 0px 4px 0px rgba(0, 0, 0, 0.05);
  border-radius: 18px 0px 0px 18px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(10px);
  padding-right: 12px;
}
.backHomeTwo {
  right: -35px;
  z-index: 95;
}
.item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  // width: 38px;
  span {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
}
.item:last-child {
  border-right: 0;
}
.show_left_imgB {
  margin: 0 14px 0 11px;
}
.show_left_img {
  margin: 0 10px 0 4px;
}
.show_left {
  right: 0px;
}
</style> 

<style lang="less" scoped>
.backHome_top {
  height: 44px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #f4f9ff;
  z-index: 97;
  max-width: 768px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #222222;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  img {
    margin-right: 6px;
  }
}
</style>